import { render, staticRenderFns } from "./EnrolmentResponseAgreement.vue?vue&type=template&id=2dfb1dcc&scoped=true"
import script from "./EnrolmentResponseAgreement.vue?vue&type=script&lang=js"
export * from "./EnrolmentResponseAgreement.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentResponseAgreement.vue?vue&type=style&index=0&id=2dfb1dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb1dcc",
  null
  
)

export default component.exports